export const BaseURL = 'https://ae-dev.abuerdan.com/api/';
export const GeoInfoAPIKey='cukaxpijmlwns8b5';
export const versionNumber = 'V.17.03.00';